import { gql } from '@apollo/client/core'

export const similarProductsQuery = gql`
  query getSimilarProducts($id: ID!, $offset: Int!, $limit: Int!) {
  similarProducts(id: $id, offset: $offset, limit: $limit) {
    totalItemsCount
    offset
    limit
    items {
      id
      productImage
      displayName
      shortDisplayName
      categoryId
      minPrice
      maxPrice
      minCampaignPrice
      maxCampaignPrice
      highestCampaignRatio
      minProductQuantity
      maxProductQuantity
      quantityUnit
      printTag
    }
  }
}
`
